/* assets/aura-serum-product.js
   Scoped per [data-vp-root] instance so it works even if the theme editor
   re-renders the section (which does NOT refire DOMContentLoaded), and even
   if the section appears more than once on the page.

   This file ALSO ships its own self-contained AJAX cart drawer
   (#vp-ajax-cart-drawer). It does not depend on your theme's cart drawer
   markup or section ids, so "add to cart doesn't visibly update" is fixed
   guaranteed, regardless of theme. After every successful add, it pulls the
   live cart from /cart.js and renders it in a slide-in panel.
*/
(function () {
  /* =========================================================
     SELF-CONTAINED AJAX CART DRAWER
     Built once globally (not per product-section instance).
  ========================================================= */
  var VP_DRAWER_ID = 'vp-ajax-cart-drawer';
  var vpDrawerEl = null;

  function vpEnsureDrawer() {
    if (vpDrawerEl) return vpDrawerEl;

    // Inject styles once
    if (!document.getElementById('vp-ajax-cart-drawer-styles')) {
      var style = document.createElement('style');
      style.id = 'vp-ajax-cart-drawer-styles';
      style.textContent = `
        #${VP_DRAWER_ID}-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,0.4);
          z-index: 99998; opacity: 0; pointer-events: none;
          transition: opacity 0.25s ease;
        }
        #${VP_DRAWER_ID}-overlay.vp-open { opacity: 1; pointer-events: auto; }
        #${VP_DRAWER_ID} {
          position: fixed; top: 0; right: 0; height: 100%; width: min(400px, 92vw);
          background: #fff; z-index: 99999; box-shadow: -8px 0 24px rgba(0,0,0,0.15);
          transform: translateX(100%); transition: transform 0.3s ease;
          display: flex; flex-direction: column; font-family: inherit;
        }
        #${VP_DRAWER_ID}.vp-open { transform: translateX(0); }
        #${VP_DRAWER_ID} .vp-cd-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 18px 20px; border-bottom: 1px solid #eee;
        }
        #${VP_DRAWER_ID} .vp-cd-header h3 { margin: 0; font-size: 17px; }
        #${VP_DRAWER_ID} .vp-cd-close {
          background: none; border: none; font-size: 22px; line-height: 1;
          cursor: pointer; padding: 4px 8px; color: #333;
        }
        #${VP_DRAWER_ID} .vp-cd-items {
          flex: 1; overflow-y: auto; padding: 12px 20px;
        }
        #${VP_DRAWER_ID} .vp-cd-item {
          display: flex; gap: 12px; padding: 14px 0; border-bottom: 1px solid #f0f0f0;
        }
        #${VP_DRAWER_ID} .vp-cd-item img {
          width: 64px; height: 64px; object-fit: cover; border-radius: 6px; flex-shrink: 0;
        }
        #${VP_DRAWER_ID} .vp-cd-item-info { flex: 1; min-width: 0; }
        #${VP_DRAWER_ID} .vp-cd-item-title {
          font-size: 14px; font-weight: 600; margin: 0 0 4px; line-height: 1.3;
        }
        #${VP_DRAWER_ID} .vp-cd-item-variant { font-size: 12px; color: #777; margin: 0 0 8px; }
        #${VP_DRAWER_ID} .vp-cd-item-row {
          display: flex; align-items: center; justify-content: space-between;
        }
        #${VP_DRAWER_ID} .vp-cd-qty {
          display: flex; align-items: center; gap: 8px; border: 1px solid #ddd;
          border-radius: 6px; padding: 2px 8px;
        }
        #${VP_DRAWER_ID} .vp-cd-qty button {
          background: none; border: none; font-size: 15px; cursor: pointer;
          width: 20px; height: 20px; padding: 0;
        }
        #${VP_DRAWER_ID} .vp-cd-item-price { font-size: 13px; font-weight: 600; }
        #${VP_DRAWER_ID} .vp-cd-remove {
          background: none; border: none; font-size: 12px; color: #999;
          text-decoration: underline; cursor: pointer; margin-left: 8px; padding: 0;
        }
        #${VP_DRAWER_ID} .vp-cd-empty {
          text-align: center; color: #888; padding: 60px 20px; font-size: 14px;
        }
        #${VP_DRAWER_ID} .vp-cd-footer {
          border-top: 1px solid #eee; padding: 16px 20px 20px;
        }
        #${VP_DRAWER_ID} .vp-cd-subtotal-row {
          display: flex; justify-content: space-between; font-size: 15px;
          font-weight: 600; margin-bottom: 12px;
        }
        #${VP_DRAWER_ID} .vp-cd-checkout-btn {
          display: block; width: 100%; text-align: center; padding: 13px;
          background: #111; color: #fff; border: none; border-radius: 6px;
          font-size: 15px; font-weight: 600; cursor: pointer; text-decoration: none;
        }
        #${VP_DRAWER_ID} .vp-cd-checkout-btn:disabled { opacity: 0.5; cursor: not-allowed; }
      `;
      document.head.appendChild(style);
    }

    var overlay = document.createElement('div');
    overlay.id = VP_DRAWER_ID + '-overlay';
    overlay.addEventListener('click', vpCloseDrawer);

    var drawer = document.createElement('div');
    drawer.id = VP_DRAWER_ID;
    drawer.innerHTML =
      '<div class="vp-cd-header">' +
        '<h3>Your Cart</h3>' +
        '<button type="button" class="vp-cd-close" aria-label="Close cart">&times;</button>' +
      '</div>' +
      '<div class="vp-cd-items"></div>' +
      '<div class="vp-cd-footer">' +
        '<div class="vp-cd-subtotal-row"><span>Subtotal</span><span class="vp-cd-subtotal-val">—</span></div>' +
        '<a href="/checkout" class="vp-cd-checkout-btn">Checkout</a>' +
      '</div>';

    drawer.querySelector('.vp-cd-close').addEventListener('click', vpCloseDrawer);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    vpDrawerEl = { drawer: drawer, overlay: overlay };
    return vpDrawerEl;
  }

  function vpOpenDrawer() {
    var d = vpEnsureDrawer();
    d.overlay.classList.add('vp-open');
    d.drawer.classList.add('vp-open');
    document.body.style.overflow = 'hidden';
  }

  function vpCloseDrawer() {
    if (!vpDrawerEl) return;
    vpDrawerEl.overlay.classList.remove('vp-open');
    vpDrawerEl.drawer.classList.remove('vp-open');
    document.body.style.overflow = '';
  }

  function vpMoneyFallback(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    return (format || '₹{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function vpRenderCart(cart) {
    var d = vpEnsureDrawer();
    var itemsEl = d.drawer.querySelector('.vp-cd-items');
    var subtotalEl = d.drawer.querySelector('.vp-cd-subtotal-val');
    var checkoutBtn = d.drawer.querySelector('.vp-cd-checkout-btn');

    if (!cart || !cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="vp-cd-empty">Your cart is empty.</div>';
      subtotalEl.textContent = vpMoneyFallback(0);
      checkoutBtn.setAttribute('disabled', 'disabled');
      return;
    }

    checkoutBtn.removeAttribute('disabled');
    subtotalEl.textContent = vpMoneyFallback(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item, idx) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_100x$1$2') : '';
      var variantText = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="vp-cd-item-variant">' + item.variant_title + '</p>'
        : '';
      return (
        '<div class="vp-cd-item" data-line="' + (idx + 1) + '">' +
          (img ? '<img src="' + img + '" alt="' + (item.product_title || '') + '">' : '') +
          '<div class="vp-cd-item-info">' +
            '<p class="vp-cd-item-title">' + item.product_title + '</p>' +
            variantText +
            '<div class="vp-cd-item-row">' +
              '<div class="vp-cd-qty">' +
                '<button type="button" class="vp-cd-qty-minus" data-line="' + (idx + 1) + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" class="vp-cd-qty-plus" data-line="' + (idx + 1) + '">+</button>' +
              '</div>' +
              '<span class="vp-cd-item-price">' + vpMoneyFallback(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="vp-cd-remove" data-line="' + (idx + 1) + '">Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    // Wire up qty +/- and remove using /cart/change.js
    itemsEl.querySelectorAll('.vp-cd-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        vpChangeLine(parseInt(btn.dataset.line, 10), 1);
      });
    });
    itemsEl.querySelectorAll('.vp-cd-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        vpChangeLine(parseInt(btn.dataset.line, 10), -1);
      });
    });
    itemsEl.querySelectorAll('.vp-cd-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        vpSetLineQty(parseInt(btn.dataset.line, 10), 0);
      });
    });
  }

  function vpFetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function vpChangeLine(line, delta) {
    var itemsEl = vpEnsureDrawer().drawer.querySelector('.vp-cd-items');
    var row = itemsEl.querySelector('[data-line="' + line + '"] span');
    var current = row ? parseInt(row.textContent, 10) : null;
    if (current === null) return;
    vpSetLineQty(line, Math.max(0, current + delta));
  }

  function vpSetLineQty(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        vpRenderCart(cart);
        vpUpdateCartCountBubbleGlobal(cart);
      })
      .catch(function () {});
  }

  function vpUpdateCartCountBubbleGlobal(cart) {
    var apply = function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
      });
      document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
        el.textContent = c.item_count;
      });
    };
    if (cart) { apply(cart); return; }
    vpFetchCart().then(apply).catch(function () {});
  }

  // Expose a small API in case you want to trigger the drawer from elsewhere
  // (e.g. a header cart icon click) without duplicating this logic.
  window.vpCartDrawer = {
    open: function () {
      vpFetchCart().then(function (cart) {
        vpRenderCart(cart);
        vpOpenDrawer();
      });
    },
    close: vpCloseDrawer,
    refresh: function () {
      return vpFetchCart().then(function (cart) {
        vpRenderCart(cart);
        vpUpdateCartCountBubbleGlobal(cart);
        return cart;
      });
    }
  };

  /* =========================================================
     PRODUCT SECTION LOGIC
  ========================================================= */
  function initAll() {
    document.querySelectorAll('[data-vp-root]').forEach(initOne);
  }

  function initOne(root) {
    if (root.dataset.vpInitialized === 'true') return;
    root.dataset.vpInitialized = 'true';

    const variantsScript = root.querySelector('[data-vp-variants-json]');
    const moneyFormatScript = root.querySelector('[data-vp-money-format]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const moneyFormat = moneyFormatScript ? JSON.parse(moneyFormatScript.textContent) : '₹{{amount}}';

    let qty = 1;

    const mainImages = Array.from(root.querySelectorAll('[data-vp-main-image]'));
    const thumbs = Array.from(root.querySelectorAll('[data-vp-thumb]'));
    const qtyValEl = root.querySelector('[data-vp-qty-val]');
    const cartBtnPriceEl = root.querySelector('[data-vp-cart-btn-price]');
    const priceEl = root.querySelector('[data-vp-price]');
    const comparePriceEl = root.querySelector('[data-vp-compare-price]');
    const savePillEl = root.querySelector('[data-vp-save-pill]');
    const variantIdInput = root.querySelector('[data-vp-variant-id]');
    const optionSelects = Array.from(root.querySelectorAll('[data-vp-option-select]'));
    const form = root.querySelector('[data-vp-form]');
    const addCartBtn = root.querySelector('[data-vp-add-cart-btn]');
    const addCartLabel = root.querySelector('[data-vp-add-cart-label]');
    const buyNowBtn = root.querySelector('[data-vp-buy-now-btn]');
    const toast = document.querySelector('[data-vp-toast]') || root.querySelector('[data-vp-toast]');

    /* ---------- Gallery ---------- */
    function setActiveImage(index) {
      mainImages.forEach(img => {
        img.classList.toggle('active', img.dataset.index === String(index));
      });
      thumbs.forEach(t => {
        t.classList.toggle('active', t.dataset.index === String(index));
      });
    }

    function getActiveIndex() {
      const activeThumb = thumbs.find(t => t.classList.contains('active'));
      return activeThumb ? parseInt(activeThumb.dataset.index, 10) : 0;
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        setActiveImage(thumb.dataset.index);
      });
    });

    const arrowPrev = root.querySelector('[data-vp-arrow-prev]');
    const arrowNext = root.querySelector('[data-vp-arrow-next]');
    if (arrowPrev && mainImages.length > 1) {
      arrowPrev.addEventListener('click', () => {
        const idx = getActiveIndex();
        const nextIdx = (idx - 1 + mainImages.length) % mainImages.length;
        setActiveImage(nextIdx);
      });
    }
    if (arrowNext && mainImages.length > 1) {
      arrowNext.addEventListener('click', () => {
        const idx = getActiveIndex();
        const nextIdx = (idx + 1) % mainImages.length;
        setActiveImage(nextIdx);
      });
    }

    const track = root.querySelector('.vp-thumbs-track') || document.querySelector('.vp-thumbs-track');
    const thumbNextBtn = root.querySelector('#thumbNext') || document.getElementById('thumbNext');
    const thumbPrevBtn = root.querySelector('#thumbPrev') || document.getElementById('thumbPrev');

    if (thumbNextBtn && track) {
      thumbNextBtn.addEventListener('click', () => {
        track.scrollBy({ left: 120, behavior: 'smooth' });
      });
    }
    if (thumbPrevBtn && track) {
      thumbPrevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -120, behavior: 'smooth' });
      });
    }

    /* ---------- Quantity stepper ---------- */
    const decreaseBtn = root.querySelector('[data-vp-qty-decrease]');
    const increaseBtn = root.querySelector('[data-vp-qty-increase]');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', () => {
        qty = Math.max(1, qty - 1);
        renderQty();
      });
    }
    if (increaseBtn) {
      increaseBtn.addEventListener('click', () => {
        qty += 1;
        renderQty();
      });
    }

    function renderQty() {
      if (qtyValEl) qtyValEl.textContent = qty;
      updateCartButtonPrice();
    }

    function currentVariant() {
      if (!variantIdInput) return variants[0];
      return variants.find(v => String(v.id) === String(variantIdInput.value)) || variants[0];
    }

    function updateCartButtonPrice() {
      const variant = currentVariant();
      if (!variant || !cartBtnPriceEl) return;
      cartBtnPriceEl.textContent = formatMoney(variant.price * qty);
    }

    function formatMoney(cents) {
      return vpMoneyFallback(cents, moneyFormat);
    }

    /* ---------- Variant option selects ---------- */
    function onOptionChange() {
      const selectedOptions = optionSelects.map(s => s.value);
      const matched = variants.find(v => {
        const vOptions = [v.option1, v.option2, v.option3].filter(Boolean);
        return vOptions.length === selectedOptions.length &&
          vOptions.every((opt, i) => opt === selectedOptions[i]);
      });
      if (!matched) return;

      if (variantIdInput) variantIdInput.value = matched.id;
      if (priceEl) priceEl.textContent = formatMoney(matched.price);

      if (matched.compare_at_price && matched.compare_at_price > matched.price) {
        const discount = Math.round(((matched.compare_at_price - matched.price) / matched.compare_at_price) * 100);
        if (comparePriceEl) { comparePriceEl.textContent = formatMoney(matched.compare_at_price); comparePriceEl.style.display = ''; }
        if (savePillEl) { savePillEl.textContent = 'SAVE ' + discount + '%'; savePillEl.style.display = ''; }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (savePillEl) savePillEl.style.display = 'none';
      }

      const isAvailable = !!matched.available;
      if (addCartBtn) addCartBtn.disabled = !isAvailable;
      if (buyNowBtn) buyNowBtn.disabled = !isAvailable;
      if (addCartLabel) {
        addCartLabel.innerHTML = isAvailable
          ? 'Add to cart · <span data-vp-cart-btn-price></span>'
          : 'Sold out';
      }
      const newPriceSpan = root.querySelector('[data-vp-cart-btn-price]');
      if (newPriceSpan) newPriceSpan.textContent = formatMoney(matched.price * qty);

      if (matched.featured_image && matched.featured_image.id) {
        const matchIndex = mainImages.findIndex(img => img.dataset.imageId === String(matched.featured_image.id));
        if (matchIndex > -1) setActiveImage(matchIndex);
      }
    }

    optionSelects.forEach(select => {
      select.addEventListener('change', onOptionChange);
    });

    /* ---------- Toast ---------- */
    let toastTimer;
    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('show'), 2400);
    }

    /* ---------- Add to cart (AJAX Cart API) ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(false);
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(true);
      });
    }

    function addToCart(redirectToCheckout) {
      const variant = currentVariant();
      if (!variant) {
        console.warn('[aura-serum-product] addToCart called but no variant could be resolved.');
        return;
      }

      const originalLabel = addCartLabel ? addCartLabel.innerHTML : '';
      if (addCartBtn) addCartBtn.disabled = true;
      if (addCartLabel) addCartLabel.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: qty })
      })
        .then(res => {
          if (!res.ok) return res.json().then(err => Promise.reject(err));
          return res.json();
        })
        .then(() => {
          if (redirectToCheckout) {
            window.location.href = '/checkout';
            return;
          }
          showToast('Added ' + qty + ' × ' + variant.name + ' to cart');
          // Guaranteed visible update: pull fresh cart and open our own drawer
          window.vpCartDrawer.refresh().then(function (cart) {
            vpOpenDrawer();
          });
        })
        .catch(err => {
          console.error('[aura-serum-product] Add to cart failed:', err);
          showToast((err && err.description) || 'Could not add to cart. Please try again.');
        })
        .finally(() => {
          if (addCartBtn) {
            addCartBtn.disabled = !variant.available;
          }
          if (addCartLabel) addCartLabel.innerHTML = originalLabel;
        });
    }

    renderQty();
  }

  // Normal page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor injects/reloads this section
  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector ? event.target.querySelector('[data-vp-root]') : null;
    if (root) initOne(root);
    else initAll();
  });

  // Some themes/editor states only fire a generic load on the block/section wrapper
  document.addEventListener('shopify:block:select', initAll);
})();